var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnderline17(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 479 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.364 18.851a2787.54 2787.54 0 01141.551-9.427 2785.99 2785.99 0 01141.382-2.2c26.6.264 53.2.913 79.781 1.937-.27-1.987-.53-3.984-.8-5.97-28.028 8.92-57.325 12.113-86.582 13.045-29.957.953-59.953-.111-89.91-.223a3386.98 3386.98 0 00-94.114.953c-31.205.75-62.41 1.926-93.585 3.527a3387.871 3387.871 0 00-93.456 6.103c-3.885.304-7.78.618-11.666.942-2.578.213-3.966 3.173-2.118 5.19 6.403 7.015 16.342 9.853 25.431 7.41 3.726-1.003 2.148-6.872-1.598-5.869-7.102 1.906-14.623-.395-19.598-5.849-.709 1.734-1.408 3.457-2.117 5.19a3422.26 3422.26 0 0193.904-6.457c31.325-1.713 62.68-3 94.045-3.852 31.365-.851 62.74-1.267 94.114-1.246 30.316.02 60.652.993 90.968.476 29.327-.497 58.894-2.777 87.343-10.4a251.318 251.318 0 0010.538-3.092c3.236-1.034 2.617-5.839-.799-5.97a2792.63 2792.63 0 00-141.851-1.855 2783.68 2783.68 0 00-141.292 5.352c-26.55 1.682-53.08 3.75-79.571 6.193-3.816.355-3.845 6.447 0 6.092z",
    fill: "#121318",
    stroke: "#121318",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgUnderline17;